export const DirectionType = Object.freeze({
    ASCENDING: Symbol("ascending"),
    DESCENDING: Symbol("descending"),
});
